import React, { FunctionComponent } from 'react';
import { Presentation } from './presentation';

type Props = {
  keyword: string;
  onChangeKeyword: (kw: string) => void;
  onSubmit: () => void;
};

export const Component: FunctionComponent<Props> = ({ keyword, onChangeKeyword, onSubmit }) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeKeyword(e.target.value);
  };

  return (
    <Presentation
      keyword={keyword}
      onChangeKeyword={handleChange}
      handleSubmit={handleSubmit}
      onSubmit={onSubmit}
    />
  );
};
